import { Component, OnInit } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastNotifService } from '../../../../../core/services/toastNotif.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { NgxMatTimepickerModule } from 'ngx-mat-timepicker';
import { ToastrService } from 'ngx-toastr';
import { CookieService } from 'ngx-cookie-service';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { LanguageService } from '../../../../../core/services/language.service';
import { Subscription } from 'rxjs';
import {
  MatMomentDateModule,
  MomentDateAdapter,
} from '@angular/material-moment-adapter';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
  MatNativeDateModule,
} from '@angular/material/core';
import { HomeTopUpModel, MyProfile, MyProfilePayload } from '../../../../../core/models/user.model';
import { StatusAPIResponse } from '../../../../../core/models/information.model';
import { PssLoadingComponent } from "../../../../../tools/template/pss/pss-loading/pss-loading.component";
import { ToastWarnComponent } from "../../../../../tools/template/toast/toast-warn/toast-warn.component";
import { ToastFailedComponent } from "../../../../../tools/template/toast/toast-failed/toast-failed.component";
import { ToastSuccessComponent } from "../../../../../tools/template/toast/toast-success/toast-success.component";
import { ToastCustomService } from '../../../../../tools/services/toast/toast-custom/toastCustom.service';
import { ApiUserService } from '../../../../../core/services/api/User/api-user';
import { ApiTopUpService } from '../../../../../core/services/api/Topup/api-topup';
import { LiffService } from '../../../../../core/services/liff.service';

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
@Component({
  selector: 'app-profile-edit',
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatMomentDateModule,
    NgxMatTimepickerModule,
    PssLoadingComponent,
  ],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
  templateUrl: './profile-edit.component.html',
  styleUrl: './profile-edit.component.css'
})
export class ProfileEditComponent {
  // function
  currentLang: "TH" | "EN" = 'TH';
  sub!: Subscription;
  userLanguage: String = 'TH';
  selectedFirstname: any = null;
  myProfile: MyProfile | null = null;
  uid: string = '';
  token: string = '';
  isLoading: boolean = false;
  displayName: string = '';
  pictureUrl: string = '';

  // user
  name: string = '';
  email: string = '';
  brirthDate: string = '';
  phoneOne: string = '';
  phoneTwo: string = '';
  address: string = '';
  dateOfBirth: Date | null = null;
  today = new Date();

  isMenuOpen = false;
  selectedOption: string = '';
  options: string[] = ['ตัวเลือกที่ 1', 'ตัวเลือกที่ 2', 'ตัวเลือกที่ 3'];

  isWhereOpen: String = ''; // เพิ่มตัวแปร isOpen เพื่อเปิด/ปิด dropdown

  // HOME TOPUP
  topUpData: HomeTopUpModel = {
    vehicleCount: 0,
    evCount: 0,
    amount: 0,
    activateCard: 0,
    notify: 0,
  };

  // Alert
  isSuccess: boolean = false;
  textSuccess: string = '';
  detailSuccess: string = '';
  isWarning: boolean = false
  textWarn: string = ''
  detailWarn: string = ''
  isError: boolean = false
  textError: string = ''
  detailError: string = ''


  constructor(
    private cookieService: CookieService,
    private apiUserService: ApiUserService,
    private apiTopUpService: ApiTopUpService,
    private liffService: LiffService,
    private toast: ToastNotifService,
    private toastCustomService: ToastCustomService,
    private router: Router,
    private languageService: LanguageService,
    private location: Location
  ) {
    this.sub = this.languageService.currentLang$.subscribe((lang) => {
      this.currentLang = lang;
    });
  }

  ngOnInit(): void {
    this.uid =
      this.cookieService.get('line_uid') ||
      localStorage.getItem('line_uid') ||
      '';
    // JWT is HttpOnly cookie — token_user no longer used
    this.token = '';
    this.displayName = this.cookieService.get('display_name') || localStorage.getItem('display_name') || 'คุณ ณัฐพล อัศวาภิรมย์';
    const rawPic = this.cookieService.get('picture_url') || localStorage.getItem('picture_url') || '';
    this.pictureUrl = (rawPic && rawPic !== 'null' && rawPic !== 'undefined' && !rawPic.includes('person-home.png')) ? rawPic : '';
    this.getProgile();
  }

  getProgile() {
    this.isLoading = true;
    this.apiUserService.GetProfile(this.token, this.uid).subscribe({
      next: (response: MyProfile) => {
        this.isLoading = false;
        if (response) {
          this.myProfile = response;
          this.name = this.myProfile.name;
          this.email = this.myProfile.email;
          this.phoneOne = this.myProfile.contactPhone;
          this.dateOfBirth = this.myProfile.birthday;
        } else {
          console.log('No data');
        }
      },
      error: (error) => {
        console.error('API error:', error);
        this.isLoading = false;
      },
    });
  }

  /*#################################################### Function ################################################*/
  /* --- Style --- */
  showWarning(text: string, detail: string = '') {
    // this.toast.warning(text);
    this.toastCustomService.showWarning('', text)
  }
  showError(text: string, detail: string = '') {
    // this.toast.error(text);
    this.toastCustomService.showError('', text)
  }
  showSuccess(text: string, detail: string = '') {
    // this.toast.success(text);
    this.toastCustomService.showSuccess('', text)
  }

  /* --- Function --- */
  /**
   * รองรับการเลือกไฟล์รูปภาพเพื่ออัปเดตโปรไฟล์
   */
  onFileSelected(event: any): void {
    const file = event.target.files?.[0];
    if (!file) return;

    if (!file.type.startsWith('image/')) {
      this.showError(this.currentLang === 'TH' ? 'กรุณาเลือกไฟล์รูปภาพเท่านั้น' : 'Please select an image file');
      return;
    }

    const reader = new FileReader();
    reader.onload = () => {
      const base64Image = reader.result as string;
      this.uploadProfilePicture(base64Image);
    };
    reader.readAsDataURL(file);
  }

  /**
   * อัปเดตรูปภาพโปรไฟล์ผ่าน LiffService และ API
   */
  async uploadProfilePicture(base64Image: string): Promise<void> {
    this.isLoading = true;
    this.pictureUrl = base64Image;

    const success = await this.liffService.updateProfilePicture(base64Image);
    this.isLoading = false;

    if (success) {
      this.showSuccess(
        this.currentLang === 'TH' ? 'อัปเดตรูปโปรไฟล์สำเร็จ' : 'Profile picture updated successfully'
      );
    } else {
      this.showError(
        this.currentLang === 'TH' ? 'อัปเดตรูปโปรไฟล์ไม่สำเร็จ' : 'Failed to update profile picture'
      );
    }
  }

  handleLanguageChange(value: String): void {
    console.log(`Selected Langauge : ${value}`);
    if (value == 'TH') {
      this.userLanguage = value; // อัปเดตค่า selectedlangauge เมื่อเลือก
    } else if (value == 'EN') {
      this.userLanguage = value; // อัปเดตค่า selectedlangauge เมื่อเลือก
    }
  }
  compareDates() {
    const today = new Date(); // get current date
    var selectDate = new Date(this.brirthDate);

    if (!this.brirthDate) {
      alert('กรุณาเลือกวันที่ให้ครบถ้วน');
      return;
    }

    if (selectDate > today) {
      alert('กรุณาใส่วันเกิดให้ถูกต้อง');
    } else {
      alert('วันที่ถูกต้อง');
    }
  }
  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  filterPastDates = (d: Date | null): boolean => {
    const today = new Date();
    return d ? d <= today : false;
  };

  selectOption(option: string) {
    this.selectedOption = option;
    this.isMenuOpen = false;
  }

  saveProfile() {
    this.isLoading = true;
    const date = new Date(this.dateOfBirth || '');
    date.setHours(date.getHours() + 7);

    const payload: MyProfilePayload = {
      name: this.name,
      email: this.email,
      contactPhone: this.phoneOne,
      birthday: date,
      uid: this.uid,
    };

    if (payload) {
      // console.log(payload);
      this.apiUserService.UpdateProfile(payload, this.token).subscribe({
        next: (res: StatusAPIResponse) => {
          this.isLoading = false;
          this.showSuccess(
            this.currentLang === 'TH' ? 'บันทึกสำเร็จ' : 'Saved Successful'
          );
        },
        error: (err) => {
          this.isLoading = false;
          console.error('❌  ไม่สำเร็จ:', err);
          this.showError('บันทึกไม่สำเร็จ');
        },
        complete: () => {
          this.isLoading = false;
        },
      });
    } else {
      console.log('No Payload');
    }
  }

  goback() {
    if (window.history.length > 1) {
      this.location.back();
    } else {
      this.router.navigate(['/home']);
    }
  }

  onNumberInput(field: string, event: any) {
    const val = event.target.value.replace(/[^0-9]/g, '');
    if (field === 'phoneOne') {
      this.phoneOne = val;
    }
    event.target.value = val;
  }

  goAddressPage() {
    this.router.navigate(['/address']);
  }

  /*############################################# API #################################################*/
  /**
   * ดึงข้อมูล Home Top Up
   */
  getHomeTopUp() {
    this.isLoading = true;
    if (this.uid) {
      this.apiTopUpService.getHomeTopUp(this.uid, this.token).subscribe({
        next: (response: HomeTopUpModel) => {
          console.log('response data Home Top Up : ', response);
          this.isLoading = false;
          this.topUpData = response;

          sessionStorage.setItem('homeTopUp', JSON.stringify(response));
        },
        error: (err) => {
          console.error('โหลดข้อมูล Home Top Up ล้มเหลว', err);
          this.isLoading = false;
        },
      });
    } else {
      this.showWarning(
        this.currentLang === 'TH'
          ? 'ไม่พบ LINE uid กรุณาเข้าใหม่ผ่าน /register'
          : 'Missing LINE uid. Please re-enter via /register.'
      );
      return;
    }
  }
}

